import React, {useEffect, useState} from 'react';
import styles from './user-online-ststus.module.scss';
import {useRouteMatch} from "react-router-dom/cjs/react-router-dom";
import {fetchUserData} from "../../store/testresults/userstatus/actions";
import {useDispatch, useSelector} from "react-redux";
import ComponentLoader from "../ComponentLoader";

function UserOnlineStatus({ userId }) {
	const match = useRouteMatch();
	const dispatch = useDispatch();
	const {userData, userDataisLoading: loading} = useSelector(state => state.UserStatus);
	const [id] = useState(match?.params?.id);
	const [status, setStatus] = useState('');
	const isUserOnlineStatusStyles = userData?.is_online ? styles.online : styles.offline
	const isOnlineStyle = userData?.active ? isUserOnlineStatusStyles : styles.deactivated
	
	useEffect(() => {
		if (id || userId) {
			dispatch(fetchUserData(id || userId));
		}
	}, [id, userId]);
	useEffect(() => {
		if (userData) {
			setStatus(userData.active
				? (userData.is_online ? 'Online' : 'Offline')
				: 'Disabled'
			);
		}
	}, [userData]);

	return (
		<div className={styles.avatarContainer}>
			{loading ? (<ComponentLoader customClass={styles.spinnerWrapper} />) : (<div className={`${styles.statusIndicator} ${isOnlineStyle}`}>{status}</div>)}
		</div>
	);
}

export default UserOnlineStatus;
